// import React, { useEffect, useState } from "react";
// import {
//   Pagination,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
// } from "@mui/material";
// // import axios from "axios";
// import BorderColorIcon from "@mui/icons-material/BorderColor";
// import Box from "@mui/material/Box";
// import Button from "@mui/material/Button";
// import Modal from "@mui/material/Modal";
// import TextField from "@mui/material/TextField";
// import MenuItem from "@mui/material/MenuItem";
// import FormControl from "@mui/material/FormControl";
// import Select from "@mui/material/Select";
// import AddIcon from "@mui/icons-material/Add";
// import { toast } from "react-toastify";
// import Radio from "@mui/material/Radio";
// import RadioGroup from "@mui/material/RadioGroup";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import FormLabel from "@mui/material/FormLabel";
// import { Active, Inactive } from "../../shared/ActivaInactive";
// import axiosInstance, { baseUrl } from "../../config/axios";
// import { Delete } from "@mui/icons-material";

// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 500,
//   border: "2px solid #000",
//   boxShadow: 24,
//   p: 4,
//   rounded: 2,
// };

// const Slider = () => {
//   const storeId = localStorage.getItem("store_id");
//   const [data, setData] = useState([]);
//   const [open1, setOpen1] = React.useState(false);
//   const [categoryData, setCategoryData] = useState([]);
//   const [page, setPage] = useState(1);
//   // add product varient start
//   const [categoryId, setCategoryId] = useState("");
//   const [image, setImage] = useState("");
//   const [mainTitle, setMainTitle] = useState("");
//   const [description, setDescription] = useState("");
//   const [buttonName, setButtonName] = useState("");
//   const [link, setLink] = useState("");
//   const [sliderSection, setSliderSection] = useState("");
//   const [active, setActive] = useState("");
//   const [rowData, setRowData] = useState({});
//   const [search, setSearch] = useState("");
//   const [ids, setIds] = useState(null);
//   const handleOpen1 = () => setOpen1(true);
//   const handleClose1 = () => setOpen1(false);
//   const sliderListData = () => {
//     axiosInstance
//       .post(
//         `api/admin/multivendor-slider-list/`,
//         { store_id: storeId, page: page },
//         {
//           params: {
//             search: search,
//           },
//           headers: {
//             Token: localStorage.getItem("Token"),
//           },
//         },
//       )
//       .then((response) => {
//         setData(response?.data);
//       })
//       .catch((error) => {
//         console.log("", error);
//       });
//   };
//   useEffect(() => {
//     sliderListData();
//   }, [page, search]);

//   const mainCategoryList = () => {
//     axiosInstance
//       .post(
//         `api/admin/multivendor-show-main-category-list/`,
//         {
//           store_id: storeId,
//         },
//         {
//           headers: {
//             Token: localStorage.getItem("Token"),
//           },
//         },
//       )
//       .then((response) => {
//         setCategoryData(response?.data?.main_category_data);
//       })
//       .catch((error) => {
//         console.log("", error);
//       });
//   };
//   useEffect(() => {
//     mainCategoryList();
//   }, [rowData?.id, open1]);

//   const submitCategory = () => {
//     const reqbody = new FormData();
//     reqbody.append("slider_id", ids);
//     reqbody.append("store_id", storeId);
//     reqbody.append("category_id", categoryId || rowData?.category?.id);
//     reqbody.append("image", image);
//     reqbody.append("button_name", buttonName);
//     reqbody.append("slider_section", sliderSection);
//     reqbody.append("main_title", mainTitle);
//     reqbody.append("description", description);
//     reqbody.append("link", link);
//     reqbody.append("is_active_for_user ", active);
//     ids === null
//       ? axiosInstance
//           .post(`api/admin/multivendor-add-slider/`, reqbody, {
//             headers: {
//               Token: localStorage.getItem("Token"),
//             },
//           })
//           .then((response) => {
//             setMainTitle("");
//             setDescription("");
//             setCategoryId("");
//             setButtonName("");
//             setLink("");
//             setSliderSection("");
//             setImage("");
//             setActive();
//             setIds(null);
//             toast.success(response.data.message);
//             handleClose1();
//             sliderListData();
//           })
//           .catch((error) => {
//             console.log("", error);
//           })
//       : axiosInstance
//           .post(`api/admin/multivendor-update-slider/`, reqbody, {
//             headers: {
//               Token: localStorage.getItem("Token"),
//               "Content-Type": "multipart/formdata",
//             },
//           })
//           .then((response) => {
//             setMainTitle("");
//             setDescription("");
//             setCategoryId("");
//             setButtonName("");
//             setLink("");
//             setSliderSection("");
//             setImage("");
//             setActive("");
//             setIds(null);
//             toast.success(response.data.message);
//             handleClose1();
//             sliderListData();
//           })
//           .catch((error) => {
//             console.log("", error);
//           });
//   };

//   const editFunctionality = (row) => {
//     setMainTitle(row?.main_title);
//     setDescription(row?.description);
//     setButtonName(row?.button_name);
//     setLink(row?.link);
//     setSliderSection(row?.slider_section);
//     setActive(row?.is_active_for_user ? "True" : "False");
//     console.log("row data=>", row);
//     setRowData(row);
//     setIds(row?.id);
//     setDescription(row?.description);
//   };

//   const handleModalClose = () => {
//     setMainTitle("");
//     setDescription("");
//     setCategoryId("");
//     setButtonName("");
//     setLink("");
//     setSliderSection("");
//     setImage("");
//     setActive("");
//     setIds(null);
//     setRowData({});
//     handleClose1();
//   };

//   const handleChange = (event, value) => {
//     setPage(value);
//   };

//   const DeleteSlider = (id) => {
//     const reqbody = {
//       slider_id: id,
//     };

//     axiosInstance
//       .delete(`api/admin/multivendor-update-slider/`, {
//         data: reqbody,
//         headers: {
//           Token: localStorage.getItem("Token"),
//           "Content-Type": "application/json",
//         },
//       })
//       .then((response) => {
//         toast.success(response.data.message);
//         sliderListData();
//       })
//       .catch((error) => {
//         console.log("Error deleting slider:", error);
//         toast.error("Failed to delete slider. Please try again.");
//       });
//   };

//   return (
//     <div className=" !bg-slate-100">
//       <div className="flex justify-between">
//         <div className="p-2">
//           <p className="text-xl !text-black font font-bold">
//             Slider Management List
//           </p>
//         </div>
//         <div className="p-2 pt-5"></div>
//       </div>
//       <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
//         <div className="flex items-center justify-between my-2">
//           <span className="flex  gap-3">
//             <input
//               type="text"
//               className="!border-3 !border-black mx-3 !w-72 px-2 rounded-md py-1"
//               placeholder="search"
//               style={{ border: "1px solid black" }}
//               onChange={(e) => setSearch(e.target.value)}
//             />
//           </span>

//           <span>
//             <div className="text-red-500 mx-3">
//               <Button variant="outlined" color="primary" onClick={handleOpen1}>
//                 <AddIcon />
//                 Add Slider
//               </Button>
//               <Modal
//                 open={open1}
//                 onClose={handleClose1}
//                 aria-labelledby="child-modal-title"
//                 aria-describedby="child-modal-description"
//               >
//                 <Box
//                   sx={{ ...style, width: 830 }}
//                   className="rounded-md !bg-white !bg-opacity-95 !border-0"
//                 >
//                   <div
//                     id="child-modal-title "
//                     className="!text-black !underline !font-bold !pb-3 !text-center !text-xl"
//                   >
//                     {ids === null ? "Add Slider" : "Update Slider"}
//                   </div>
//                   <div className="flex justify-between w-full">
//                     <div className="w-[48%]">
//                       <div>Select Category</div>
//                       <FormControl fullWidth>
//                         <Select
//                           labelId="demo-simple-select-label"
//                           id="demo-simple-select"
//                           size="small"
//                           className="mt-1"
//                           name="main_category_id"
//                           value={categoryId || rowData?.category?.id || ""}
//                           onChange={(event) =>
//                             setCategoryId(event.target.value)
//                           }
//                         >
//                           {categoryData?.map((elem) => (
//                             <MenuItem value={elem?.id}>
//                               {elem?.category}
//                             </MenuItem>
//                           ))}
//                         </Select>
//                       </FormControl>
//                       <div className="mt-2">Enter Slider Name</div>
//                       <TextField
//                         size="small"
//                         id="outlined-basic"
//                         value={mainTitle}
//                         onChange={(event) => setMainTitle(event.target.value)}
//                         className="!w-[100%] !mt-1"
//                         placeholder="Enter Slider Name"
//                         name="product_name"
//                       />
//                       <div className="mt-2">Image</div>
//                       <div className="flex justify-between gap-x-4">
//                         <TextField
//                           size="small"
//                           type="file"
//                           onChange={(event) => setImage(event.target.files[0])}
//                           id="outlined-basic"
//                           className="!w-[100%] !mt-1"
//                           name="product_name"
//                         />
//                         {rowData.length > 0 ? (
//                           <img
//                             src={rowData?.image}
//                             alt="No"
//                             height={"8"}
//                             width={"40"}
//                             className="shadow shadow-blue-500"
//                           />
//                         ) : null}
//                       </div>

//                       <div className="mt-2">Description </div>
//                       <TextField
//                         size="small"
//                         id="outlined-basic"
//                         className="!w-[100%] !mt-1"
//                         name="product_name"
//                         placeholder="Enter Description"
//                         value={description}
//                         onChange={(event) => setDescription(event.target.value)}
//                       />
//                     </div>
//                     <div className="w-[48%]">
//                       <div className="">Button Name</div>
//                       <TextField
//                         size="small"
//                         id="outlined-basic"
//                         className="!w-[100%] !mt-1"
//                         name="offerTag"
//                         placeholder="Enter Button Name"
//                         value={buttonName}
//                         onChange={(event) => setButtonName(event.target.value)}
//                       />
//                       <div className="mt-2">Slider Section </div>
//                       <TextField
//                         size="small"
//                         id="outlined-basic"
//                         className="!w-[100%] !mt-1"
//                         name="sliderSection"
//                         placeholder="Enter Slider Section"
//                         value={sliderSection}
//                         onChange={(event) =>
//                           setSliderSection(event.target.value)
//                         }
//                       />
//                       <div className="mt-2">Link </div>
//                       <TextField
//                         size="small"
//                         id="outlined-basic"
//                         className="!w-[100%] !mt-1"
//                         name="link"
//                         placeholder="Enter Link"
//                         value={link}
//                         onChange={(event) => setLink(event.target.value)}
//                       />
//                       <FormControl>
//                         <FormLabel
//                           id="demo-row-radio-buttons-group-label"
//                           className="!text-black !mt-2"
//                         >
//                           Is Active/Deactive For User
//                         </FormLabel>
//                         <RadioGroup
//                           row
//                           aria-labelledby="demo-row-radio-buttons-group-label"
//                           name="row-radio-buttons-group"
//                           value={active}
//                           onChange={(event) => setActive(event.target.value)}
//                         >
//                           <FormControlLabel
//                             value="True"
//                             control={<Radio />}
//                             label="True"
//                           />
//                           <FormControlLabel
//                             value="False"
//                             control={<Radio />}
//                             label="False"
//                           />
//                         </RadioGroup>
//                       </FormControl>
//                     </div>
//                   </div>

//                   <Button
//                     onClick={handleModalClose}
//                     variant="contained"
//                     color="warning"
//                     className="!py-2 !mt-3"
//                   >
//                     CANCEL
//                   </Button>
//                   <Button
//                     variant="contained"
//                     type="submit"
//                     color="success"
//                     className="!py-2 !px-5 !font-bold !mt-3 !float-right"
//                     onClick={submitCategory}
//                   >
//                     {ids === null ? "ADD" : "UPDATE"}
//                   </Button>
//                 </Box>
//               </Modal>
//             </div>
//           </span>
//         </div>
//         <TableContainer
//           component={Paper}
//           sx={{ width: "100%", maxHeight: "70vh" }}
//           className="!text-black !mx-auto !bg-white overflow-auto px-2"
//         >
//           <Table stickyHeader aria-label="sticky table" size="small">
//             <TableHead>
//               <TableRow>
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   ID
//                 </TableCell>
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   CATEGORY
//                 </TableCell>
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   SLIDER NAME
//                 </TableCell>

//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   IMAGE
//                 </TableCell>
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   BUTTON NAME
//                 </TableCell>
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   SLIDER SECTION
//                 </TableCell>
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   IS (Active/Deactive)
//                 </TableCell>
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   LINK
//                 </TableCell>
//                 <TableCell
//                   style={{
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   EDIT
//                 </TableCell>

//                 <TableCell
//                   style={{
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   DELETE
//                 </TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody className="!bg-red">
//               {data &&
//                 data?.slider?.map((row, index) => (
//                   <TableRow key={row.id} className="!text-slate-700">
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {index + 1}
//                     </TableCell>
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {row?.category?.category ? row?.category?.category : "--"}
//                     </TableCell>
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {row?.main_title ? row?.main_title : "--"}
//                     </TableCell>

//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {row?.image ? (
//                         <img
//                           src={row?.image}
//                           alt="No"
//                           className="h-8 mx-auto w-8"
//                         />
//                       ) : (
//                         "--"
//                       )}
//                     </TableCell>
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {row?.button_name ? row?.button_name : "--"}
//                     </TableCell>
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {row?.slider_section ? row?.slider_section : "--"}
//                     </TableCell>
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {row?.is_active_for_user ? <Active /> : <Inactive />}
//                     </TableCell>
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {row?.link !== "/" ? (
//                         <a
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           className="!underline text-blue-600"
//                           href={row?.link}
//                         >
//                           {row?.link ? row?.link : "--"}
//                         </a>
//                       ) : row?.link ? (
//                         row?.link
//                       ) : (
//                         "--"
//                       )}
//                     </TableCell>
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       <div onClick={handleOpen1}>
//                         <BorderColorIcon
//                           className="text-green-400"
//                           onClick={() => editFunctionality(row)}
//                         />
//                       </div>
//                     </TableCell>

//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       <Delete
//                         className="text-red-500"
//                         onClick={() => DeleteSlider(row?.id)}
//                       />
//                     </TableCell>
//                   </TableRow>
//                 ))}
//             </TableBody>
//           </Table>
//           {data?.current_page !== 0 && (
//             <div className="flex justify-center p-2">
//               <Pagination
//                 page={data?.current_page}
//                 size="small"
//                 count={data?.total_pages}
//                 variant="outlined"
//                 color="primary"
//                 onChange={handleChange}
//               />
//             </div>
//           )}
//         </TableContainer>
//       </div>
//     </div>
//   );
// };

// export default Slider;

import React, { useEffect, useState } from "react";
import {
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
// import axios from "axios";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import AddIcon from "@mui/icons-material/Add";
import { toast } from "react-toastify";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import { Active, Inactive } from "../../shared/ActivaInactive";
import axiosInstance, { baseUrl } from "../../config/axios";
import { Delete } from "@mui/icons-material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const cellSx = {
  borderRight: "1px solid #D0D0D0",
  fontFamily: "'Poppins', sans-serif",
  fontSize: "11px",
  padding: "3px 8px",
  textAlign: "center",
  lineHeight: 1.2,
};

const headSx = {
  ...cellSx,
  fontWeight: 700,
  color: "#1f2937",
  whiteSpace: "nowrap",
};

const Slider = () => {
  const storeId = localStorage.getItem("store_id");
  const [data, setData] = useState([]);
  const [open1, setOpen1] = React.useState(false);
  const [categoryData, setCategoryData] = useState([]);
  const [page, setPage] = useState(1);
  // add product varient start
  const [categoryId, setCategoryId] = useState("");
  const [image, setImage] = useState("");
  const [mainTitle, setMainTitle] = useState("");
  const [description, setDescription] = useState("");
  const [buttonName, setButtonName] = useState("");
  const [link, setLink] = useState("");
  const [sliderSection, setSliderSection] = useState("");
  const [active, setActive] = useState("");
  const [rowData, setRowData] = useState({});
  const [search, setSearch] = useState("");
  const [ids, setIds] = useState(null);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);
  const sliderListData = () => {
    axiosInstance
      .post(
        `api/admin/multivendor-slider-list/`,
        { store_id: storeId, page: page },
        {
          params: {
            search: search,
          },
          headers: {
            Token: localStorage.getItem("Token"),
          },
        },
      )
      .then((response) => {
        setData(response?.data);
      })
      .catch((error) => {
        console.log("", error);
      });
  };
  useEffect(() => {
    sliderListData();
  }, [page, search]);

  const mainCategoryList = () => {
    axiosInstance
      .post(
        `api/admin/multivendor-show-main-category-list/`,
        {
          store_id: storeId,
        },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        },
      )
      .then((response) => {
        setCategoryData(response?.data?.main_category_data);
      })
      .catch((error) => {
        console.log("", error);
      });
  };
  useEffect(() => {
    mainCategoryList();
  }, [rowData?.id, open1]);

  const submitCategory = () => {
    const reqbody = new FormData();
    reqbody.append("slider_id", ids);
    reqbody.append("store_id", storeId);
    reqbody.append("category_id", categoryId || rowData?.category?.id);
    reqbody.append("image", image);
    reqbody.append("button_name", buttonName);
    reqbody.append("slider_section", sliderSection);
    reqbody.append("main_title", mainTitle);
    reqbody.append("description", description);
    reqbody.append("link", link);
    reqbody.append("is_active_for_user ", active);
    ids === null
      ? axiosInstance
          .post(`api/admin/multivendor-add-slider/`, reqbody, {
            headers: {
              Token: localStorage.getItem("Token"),
            },
          })
          .then((response) => {
            setMainTitle("");
            setDescription("");
            setCategoryId("");
            setButtonName("");
            setLink("");
            setSliderSection("");
            setImage("");
            setActive();
            setIds(null);
            toast.success(response.data.message);
            handleClose1();
            sliderListData();
          })
          .catch((error) => {
            console.log("", error);
          })
      : axiosInstance
          .post(`api/admin/multivendor-update-slider/`, reqbody, {
            headers: {
              Token: localStorage.getItem("Token"),
              "Content-Type": "multipart/formdata",
            },
          })
          .then((response) => {
            setMainTitle("");
            setDescription("");
            setCategoryId("");
            setButtonName("");
            setLink("");
            setSliderSection("");
            setImage("");
            setActive("");
            setIds(null);
            toast.success(response.data.message);
            handleClose1();
            sliderListData();
          })
          .catch((error) => {
            console.log("", error);
          });
  };

  const editFunctionality = (row) => {
    setMainTitle(row?.main_title);
    setDescription(row?.description);
    setButtonName(row?.button_name);
    setLink(row?.link);
    setSliderSection(row?.slider_section);
    setActive(row?.is_active_for_user ? "True" : "False");
    console.log("row data=>", row);
    setRowData(row);
    setIds(row?.id);
    setDescription(row?.description);
  };

  const handleModalClose = () => {
    setMainTitle("");
    setDescription("");
    setCategoryId("");
    setButtonName("");
    setLink("");
    setSliderSection("");
    setImage("");
    setActive("");
    setIds(null);
    setRowData({});
    handleClose1();
  };

  const handleChange = (event, value) => {
    setPage(value);
  };

  const DeleteSlider = (id) => {
    const reqbody = {
      slider_id: id,
    };

    axiosInstance
      .delete(`api/admin/multivendor-update-slider/`, {
        data: reqbody,
        headers: {
          Token: localStorage.getItem("Token"),
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        toast.success(response.data.message);
        sliderListData();
      })
      .catch((error) => {
        console.log("Error deleting slider:", error);
        toast.error("Failed to delete slider. Please try again.");
      });
  };

  return (
    <div className=" !bg-slate-100">
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font font-bold">
            Slider Management List
          </p>
        </div>
        <div className="p-2 pt-5"></div>
      </div>
      <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
        <div className="flex items-center justify-between my-1">
          <span className="flex gap-3">
            <input
              type="text"
              className="mx-3 !w-56 px-2 rounded-md text-xs"
              placeholder="search"
              style={{ border: "1px solid black", height: 28 }}
              onChange={(e) => setSearch(e.target.value)}
            />
          </span>

          <span>
            <div className="text-red-500 mx-3">
              <Button
                variant="outlined"
                color="primary"
                size="small"
                sx={{
                  fontSize: 11,
                  py: 0.25,
                  minHeight: 28,
                  textTransform: "none",
                }}
                onClick={handleOpen1}
              >
                <AddIcon sx={{ fontSize: 16 }} />
                Add Slider
              </Button>
              <Modal
                open={open1}
                onClose={handleClose1}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
              >
                <Box
                  sx={{ ...style, width: 830 }}
                  className="rounded-md !bg-white !bg-opacity-95 !border-0"
                >
                  <div
                    id="child-modal-title "
                    className="!text-black !underline !font-bold !pb-3 !text-center !text-xl"
                  >
                    {ids === null ? "Add Slider" : "Update Slider"}
                  </div>
                  <div className="flex justify-between w-full">
                    <div className="w-[48%]">
                      <div>Select Category</div>
                      <FormControl fullWidth>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          size="small"
                          className="mt-1"
                          name="main_category_id"
                          value={categoryId || rowData?.category?.id || ""}
                          onChange={(event) =>
                            setCategoryId(event.target.value)
                          }
                        >
                          {categoryData?.map((elem) => (
                            <MenuItem value={elem?.id}>
                              {elem?.category}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <div className="mt-2">Enter Slider Name</div>
                      <TextField
                        size="small"
                        id="outlined-basic"
                        value={mainTitle}
                        onChange={(event) => setMainTitle(event.target.value)}
                        className="!w-[100%] !mt-1"
                        placeholder="Enter Slider Name"
                        name="product_name"
                      />
                      <div className="mt-2">Image</div>
                      <div className="flex justify-between gap-x-4">
                        <TextField
                          size="small"
                          type="file"
                          onChange={(event) => setImage(event.target.files[0])}
                          id="outlined-basic"
                          className="!w-[100%] !mt-1"
                          name="product_name"
                        />
                        {rowData.length > 0 ? (
                          <img
                            src={rowData?.image}
                            alt="No"
                            height={"8"}
                            width={"40"}
                            className="shadow shadow-blue-500"
                          />
                        ) : null}
                      </div>

                      <div className="mt-2">Description </div>
                      <TextField
                        size="small"
                        id="outlined-basic"
                        className="!w-[100%] !mt-1"
                        name="product_name"
                        placeholder="Enter Description"
                        value={description}
                        onChange={(event) => setDescription(event.target.value)}
                      />
                    </div>
                    <div className="w-[48%]">
                      <div className="">Button Name</div>
                      <TextField
                        size="small"
                        id="outlined-basic"
                        className="!w-[100%] !mt-1"
                        name="offerTag"
                        placeholder="Enter Button Name"
                        value={buttonName}
                        onChange={(event) => setButtonName(event.target.value)}
                      />
                      <div className="mt-2">Slider Section </div>
                      <TextField
                        size="small"
                        id="outlined-basic"
                        className="!w-[100%] !mt-1"
                        name="sliderSection"
                        placeholder="Enter Slider Section"
                        value={sliderSection}
                        onChange={(event) =>
                          setSliderSection(event.target.value)
                        }
                      />
                      <div className="mt-2">Link </div>
                      <TextField
                        size="small"
                        id="outlined-basic"
                        className="!w-[100%] !mt-1"
                        name="link"
                        placeholder="Enter Link"
                        value={link}
                        onChange={(event) => setLink(event.target.value)}
                      />
                      <FormControl>
                        <FormLabel
                          id="demo-row-radio-buttons-group-label"
                          className="!text-black !mt-2"
                        >
                          Is Active/Deactive For User
                        </FormLabel>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                          value={active}
                          onChange={(event) => setActive(event.target.value)}
                        >
                          <FormControlLabel
                            value="True"
                            control={<Radio />}
                            label="True"
                          />
                          <FormControlLabel
                            value="False"
                            control={<Radio />}
                            label="False"
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </div>

                  <Button
                    onClick={handleModalClose}
                    variant="contained"
                    color="warning"
                    className="!py-2 !mt-3"
                  >
                    CANCEL
                  </Button>
                  <Button
                    variant="contained"
                    type="submit"
                    color="success"
                    className="!py-2 !px-5 !font-bold !mt-3 !float-right"
                    onClick={submitCategory}
                  >
                    {ids === null ? "ADD" : "UPDATE"}
                  </Button>
                </Box>
              </Modal>
            </div>
          </span>
        </div>
        <TableContainer
          component={Paper}
          sx={{ width: "100%", maxHeight: "74vh" }}
          className="!text-black !mx-auto !bg-white overflow-auto px-2"
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={headSx}>ID</TableCell>
                <TableCell sx={headSx}>CATEGORY</TableCell>
                <TableCell sx={headSx}>SLIDER NAME</TableCell>
                <TableCell sx={headSx}>IMAGE</TableCell>
                <TableCell sx={headSx}>BUTTON NAME</TableCell>
                <TableCell sx={headSx}>SLIDER SECTION</TableCell>
                <TableCell sx={headSx}>IS (ACTIVE/DEACTIVE)</TableCell>
                <TableCell sx={headSx}>LINK</TableCell>
                <TableCell sx={{ ...headSx, borderRight: "none" }}>
                  EDIT
                </TableCell>
                <TableCell sx={{ ...headSx, borderRight: "none" }}>
                  DELETE
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data &&
                data?.slider?.map((row, index) => (
                  <TableRow key={row.id} hover className="!text-slate-700">
                    <TableCell sx={cellSx}>{index + 1}</TableCell>
                    <TableCell sx={cellSx}>
                      {row?.category?.category ? row?.category?.category : "--"}
                    </TableCell>
                    <TableCell sx={cellSx}>
                      {row?.main_title ? row?.main_title : "--"}
                    </TableCell>

                    <TableCell sx={cellSx}>
                      {row?.image ? (
                        <img
                          src={row?.image}
                          alt="No"
                          className="h-6 w-6 mx-auto object-cover"
                        />
                      ) : (
                        "--"
                      )}
                    </TableCell>
                    <TableCell sx={cellSx}>
                      {row?.button_name ? row?.button_name : "--"}
                    </TableCell>
                    <TableCell sx={cellSx}>
                      {row?.slider_section ? row?.slider_section : "--"}
                    </TableCell>
                    <TableCell sx={cellSx}>
                      <div className="flex justify-center scale-75 origin-center">
                        {row?.is_active_for_user ? <Active /> : <Inactive />}
                      </div>
                    </TableCell>
                    <TableCell sx={cellSx}>
                      {row?.link !== "/" ? (
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          title={row?.link}
                          className="!underline text-blue-600 text-[11px] block max-w-[200px] truncate mx-auto"
                          href={row?.link}
                        >
                          {row?.link ? row?.link : "--"}
                        </a>
                      ) : row?.link ? (
                        row?.link
                      ) : (
                        "--"
                      )}
                    </TableCell>
                    <TableCell sx={{ ...cellSx, borderRight: "none" }}>
                      <div onClick={handleOpen1}>
                        <BorderColorIcon
                          sx={{ fontSize: 16 }}
                          className="text-green-400 cursor-pointer"
                          onClick={() => editFunctionality(row)}
                        />
                      </div>
                    </TableCell>

                    <TableCell sx={{ ...cellSx, borderRight: "none" }}>
                      <Delete
                        sx={{ fontSize: 16 }}
                        className="text-red-500 cursor-pointer"
                        onClick={() => DeleteSlider(row?.id)}
                      />
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          {data?.current_page !== 0 && (
            <div className="flex justify-center p-2">
              <Pagination
                page={data?.current_page}
                size="small"
                count={data?.total_pages}
                variant="outlined"
                color="primary"
                onChange={handleChange}
              />
            </div>
          )}
        </TableContainer>
      </div>
    </div>
  );
};

export default Slider;
